<script lang="ts">
    import { productComponents } from '$lib/components/product/productComponents/productComponents.js';
    import type { ApiSchemas } from '$lib/api/shopwareApi.js';

    export let product: ApiSchemas['Product'];
    export let cart: ApiSchemas['Cart'];

    const component =
        productComponents[product.translated?.customFields?.custom_lewo_erp_category] ?? productComponents['Wein'];
</script>

<div class="swiper-slide">
    <svelte:component this={component} {product} {cart} />
</div>
